import { ReactNode } from 'react';
import { Stack, Typography } from '@mui/material';
import { EmulatorType, PlanFamily } from '@localstack/types';
import { EMULATOR_LABELS } from '@localstack/constants';
import { EmulatorIcon } from '@localstack/ui';

const PLAN_FAMILY_LABELS: Record<PlanFamily, string> = {
  [PlanFamily.HOBBY_PLANS]: 'Hobby',
  [PlanFamily.PRO_PLANS]: 'Pro',
  [PlanFamily.TEAM_PLANS]: 'Team',
  [PlanFamily.LEGACY_PLANS]: 'Legacy',
  [PlanFamily.ENTERPRISE_PLANS]: 'Enterprise',
  [PlanFamily.TRIAL_PLANS]: 'Trial',
  [PlanFamily.PREVIEW_PLANS]: 'Preview',
  [PlanFamily.FREEMIUM_PLANS]: 'Freemium',
  [PlanFamily.BASE_PLANS]: 'Base',
  [PlanFamily.ULTIMATE_PLANS]: 'Ultimate',
  [PlanFamily.STUDENT]: 'Student',
  [PlanFamily.COMMUNITY]: 'Community',
};

export interface LicenseAssignmentPlanLabelProps {
  emulator: EmulatorType;
  /** Plan family — preferred when showing a plan name. Renders a human-readable label via PLAN_FAMILY_LABELS. */
  family?: PlanFamily;
  /** Fallback raw label (e.g. a seat count). Use when family is not available. */
  title?: string;
  hideTier?: boolean;
  /** Overrides the default per-emulator icon (e.g. to show a warning icon instead). */
  icon?: ReactNode;
}

export const LicenseAssignmentPlanLabel = ({
  emulator,
  family,
  title,
  hideTier = false,
  icon,
}: LicenseAssignmentPlanLabelProps): JSX.Element => {
  const label = family != null ? PLAN_FAMILY_LABELS[family] : title;

  return (
    <Stack direction="row" alignItems="center" spacing={0.5}>
      {icon ?? <EmulatorIcon emulator={emulator} fontSize="small" />}
      <Typography variant="body1">{EMULATOR_LABELS[emulator]}</Typography>
      {!hideTier && <Typography variant="caption">&middot;</Typography>}
      {label && !hideTier && <Typography variant="caption">{label}</Typography>}
    </Stack>
  );
};
